// extracted by mini-css-extract-plugin
export default {"nav":"user_header_nav__z0Y5+","go_back":"user_header_go_back__vFmGz","functions":"user_header_functions__8-KMg"};